/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ app: NonNullable<unknown> }} Directory_Submit_Review_Terms_NoteInputs */

const en_directory_submit_review_terms_note = /** @type {(inputs: Directory_Submit_Review_Terms_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Paid plans are subscriptions handled by ${i?.app}. You can manage them anytime in Settings → Billing.`)
};

const zh_directory_submit_review_terms_note = /** @type {(inputs: Directory_Submit_Review_Terms_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`付费方案为订阅制，由 ${i?.app} 处理。可随时在 设置 → 账单 中管理。`)
};

/**
* | output |
* | --- |
* | "Paid plans are subscriptions handled by {app}. You can manage them anytime in Settings → Billing." |
*
* @param {Directory_Submit_Review_Terms_NoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_review_terms_note = /** @type {((inputs: Directory_Submit_Review_Terms_NoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Review_Terms_NoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_review_terms_note(inputs)
	return zh_directory_submit_review_terms_note(inputs)
});
export { directory_submit_review_terms_note as "directory.submit.review.terms_note" }